import { useMutation } from "@tanstack/react-query";

import type { AccrualsRepositoryT } from "../domain/ports/accruals.repository";
import type { AccrualRowWithIndexT } from "../domain/types/accrual.types";

import { loadInitialData } from "../application/useCases/loadInitialData";

type CreateUseAccrualsParamsT = {
  accrualsRepository: AccrualsRepositoryT;
};

export const createUseAccruals = ({
  accrualsRepository,
}: CreateUseAccrualsParamsT) => {
  return function useAccruals({
    colaboraInstanceId,
  }: {
    colaboraInstanceId: string;
  }) {
    const loadInitialDataMutation = useMutation({
      mutationFn: (rows: AccrualRowWithIndexT[]) =>
        loadInitialData({ accrualsRepository, rows, colaboraInstanceId }),
    });

    return {
      loadInitialData: loadInitialDataMutation,
    };
  };
};
